// extracted by mini-css-extract-plugin
export var accordions = "styles-module--accordions--687e4";
export var cartButton = "styles-module--cartButton--1365c";
export var category = "styles-module--category--b9391";
export var container = "styles-module--container--9cc90";
export var desktop = "1340px";
export var fadeGrow = "styles-module--fade-grow--819cb";
export var fadeIn = "styles-module--fade-in--67ca4";
export var feature = "styles-module--feature--efa20";
export var features = "styles-module--features--9be4d";
export var giant = "2200px";
export var infoText = "styles-module--infoText--6767b";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var mobile = "400px";
export var pdpUpsell = "styles-module--pdpUpsell--aa34b";
export var quantity = "styles-module--quantity--e8d11";
export var selectionContainer = "styles-module--selectionContainer--af773";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var spin = "styles-module--spin--ee017";
export var stockWarningText = "styles-module--stockWarningText--50aeb";
export var tablet = "769px";
export var title = "styles-module--title--d0860";
export var upsellContainer = "styles-module--upsellContainer--22135";
export var upsellHint = "styles-module--upsellHint--890eb";
export var upsellText = "styles-module--upsellText--0350c";
export var upsellTitle = "styles-module--upsellTitle--966ce";
export var variantSelector = "styles-module--variantSelector--6c438";